export const selectITVBondInfo = (state) => state.factoryITVBond.info;

export const selectITVBondInfoLoading = (state) => state.factoryITVBond.loading;
export const selectITVBondInfoError = (state) => state.factoryITVBond.error;